import { FC } from 'react';
import { TaxField, TaxContainer } from './index.view';
import { currencyFormat } from 'utils/number';
import { useTranslation } from 'react-i18next';
interface TaxProps {
  amount: number;
}

const Tax: FC<TaxProps> = ({ amount }) => {
  const { t } = useTranslation();

  return amount > 0 ? (
    <TaxContainer>
      <TaxField>{`${t('includedTaxOf')} ${amount}%`}</TaxField>
      <TaxField>{`+${currencyFormat(amount)}`}</TaxField>
    </TaxContainer>
  ) : null;
};

export default Tax;
